module.exports = __webpack_public_path__ + "static/media/lego6.9aa835e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lego6.png
// module id = 293
// module chunks = 0